export enum UserTradingAnalyticsPriceType {
  USD = 'USD::UserTradingAnalyticsPriceType',
  NATIVE = 'NATIVE::UserTradingAnalyticsPriceType',
}
export const USER_TRADING_ANALYTICS_PRICE_TYPES = [
  UserTradingAnalyticsPriceType.USD,
  UserTradingAnalyticsPriceType.NATIVE,
] as const
